import React from "react";

const Specialtie = ({ specialty }) => {
  const { name, description, img } = specialty;
  return (
    <div className=" bg-slate-100 shadow-sm mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl   ">
      <div className="grid gap-5 row-gap-8 lg:grid-cols-2">
        <div>
          <img
            className="object-cover w-full h-56 rounded shadow-lg sm:h-96"
            src={img}
            alt=""
          />
        </div>
        <div className="flex flex-col justify-center">
          <div className="max-w-xl font-serif mb-6">
            <h2 className="max-w-lg mb-6 font-sans text-xl font-bold tracking-tight text-gray-600  sm:leading-none">
              {name}
            </h2>
            <p className="text-base text-gray-700 md:text-lg">{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Specialtie;
